// Event class that lists event names and handles events
// Note 1: not a "real" class - this is just extracted from App.js
// Note 2: handleEvent() is intended for use in App.js only, as it is THE state

const Moment = require("moment");





class Events {

  // ===============================================================================================
  constructor() {
    this.editMode = false;  // If we're in edit mode, we can't save state to sessionStorage

    this.bookmark = "MCD_PARTY_BOOKING_STATE";  // Local state savefile

    this.events = {
      APP_LOADED:          "APP_LOADED",           // App loaded
      APP_SLIDE_CHANGED:   "APP_SLIDE_CHANGED",    // Slides changed
      APP_PRICE_CHANGED:   "APP_PRICE_CHANGED",    // Price changed (via API)
      APP_WIPE_DATA:       "APP_WIPE_DATA",        // Wipe all saved data (when submitting)

      EVENTTYPE_MOD_TYPE: "EVENTTYPE_MOD_TYPE",    // Changed event type

      // INTRO_CHANGED:    "INTRO_CHANGED",        // Intro screen changes
      INTRO_ADD_CHILD:     "INTRO_ADD_CHILD",      // Added a child
      INTRO_REM_CHILD:     "INTRO_REM_CHILD",      // Removed a child
      INTRO_MOD_CHILD:     "INTRO_MOD_CHILD",      // Modify a child

      // PACKAGE_CHANGED:  "PACKAGE_CHANGED",      // Package screen changes
      PACKAGE_MOD_CHILD:   "PACKAGE_MOD_CHILD",    // Added/removed a child
      PACKAGE_MOD_ADULT:   "PACKAGE_MOD_ADULT",    // Added/removed an adult
      // PACKAGE_MOD_PREMIUM: "PACKAGE_MOD_PREMIUM",  // Toggled premium package

      // CAKE_CHANGED:     "CAKE_CHANGED",         // Cake screen changes
      CAKE_MOD_CAKE:       "CAKE_MOD_CAKE",        // Added/removed a cake
      CAKE_MOD_BYO:        "CAKE_MOD_BYO",         // Toggled bring-your-own cake
      CAKE_MOD_OPTIONAL_INCLUSIONS_NO_HOST:  "CAKE_MOD_OPTIONAL_INCLUSIONS_NO_HOST",   // Added/removed an optional inclusions

      // LOCATION_CHANGED: "LOCATION_CHANGED",     // Location screen changes
      LOCATION_MOD_QUERY:  "LOCATION_MOD_QUERY",   // Modified location search query
      LOCATION_MOD_DEST:   "LOCATION_MOD_DEST",    // Added/removed a destination

      // DATETIME_CHANGED: "DATETIME_CHANGED",     // Datetime screen changes
      DATETIME_MOD_DATE:   "DATETIME_MOD_DATE",    // Added/removed appointment date
      DATETIME_MOD_TIME:   "DATETIME_MOD_TIME",    // Added/removed time slot

      // SUMMARY_CHANGED: "SUMMARY_CHANGED",      // Summary screen changes
      SUMMARY_MOD_FIRST_NAME:   "SUMMARY_MOD_FIRST_NAME",   // Modified summary first name
      SUMMARY_MOD_LAST_NAME:   "SUMMARY_MOD_LAST_NAME",   // Modified summary last name
      SUMMARY_MOD_EMAIL:   "SUMMARY_MOD_EMAIL",   // Modified summary email

      SUMMARY_MOD_PHONE:   "SUMMARY_MOD_PHONE",   // Modified summary phone number
      SUMMARY_MOD_REQS:    "SUMMARY_MOD_REQS",    // Modified special requirements

      SUMMARY_TERMS_AND_COND: "SUMMARY_TERMS_AND_COND",    // Modified terms and conditions
      SUMMARY_PRIVACY_COLLECTION: "SUMMARY_PRIVACY_COLLECTION",
    }
  }



  // ===============================================================================================
  // Extract a parameter
  _extract(_sCurrent, _sChanged, keyname) {
    // if (_sChanged.hasOwnProperty(keyname)) {
    //   console.log(`Using changed state '${keyname}'`, _sChanged[keyname]);
    // } else {
    //   console.log(`Using current state '${keyname}'`, _sCurrent[keyname]);
    // }
    return (_sChanged.hasOwnProperty(keyname)) ? _sChanged[keyname] : _sCurrent[keyname];
  }



  // ===============================================================================================
  // Recalculates the price of this package (_sCurrent, _sChanged)
  _recalculatePrice(_sCurrent, _sChanged) {
    // --------------------------------
    // First, calculate package price

    let minChildren = this._extract(_sCurrent, _sChanged, "intro_starList").length;
    let numChildren = this._extract(_sCurrent, _sChanged, "package_numChilds");
    let selLocation = this._extract(_sCurrent, _sChanged, "location_selLocation");
    let minCapacity = (selLocation) ? selLocation.min_capacity : 1;
    let childrenBillable = minChildren + numChildren;

    // If we have location specific products, use them, otherwise use the default products
    let products = (selLocation && selLocation.products) || this._extract(_sCurrent, _sChanged, "app_cache_products");

    let priceOfStandard = (products['happy_party_package']) ? products['happy_party_package'].price : 0;
    let priceOfNoHost   = (products['no_host_package']) ? products['no_host_package'].price : 0;
    let priceOfCake = (products['ice_cream_cake']) ? products['ice_cream_cake'].price : 0;

    if (childrenBillable < minCapacity) {
      childrenBillable = minCapacity;
    }

    let pricePerChild   = priceOfStandard;
    // let pricePerChild   = (isPremium) ? priceOfPremium : priceOfStandard;
    pricePerChild   = (_sCurrent.eventType === "no-host") ? priceOfNoHost : priceOfStandard;


    let packagePrice = pricePerChild * (childrenBillable);

    // --------------------------------
    // Second, calculate cake price

    let numCakes = this._extract(_sCurrent, _sChanged, "cake_numCakes");
    let isByo    = this._extract(_sCurrent, _sChanged, "cake_isByo");
    let numOptionalInclusionsNoHost = this._extract(_sCurrent, _sChanged, "cake_numOptionalInclusionsNoHost");
    let pricePerCake = (isByo) ? priceOfCake : priceOfCake;
    let cakePrice = pricePerCake * numCakes;
    let optionalInclusionsPrice = 0;
    for (let key in numOptionalInclusionsNoHost) {
      // Find inclustions with an order count greater than 0
      if (numOptionalInclusionsNoHost[key] > 0 && products[key] !== undefined) {
        let tempProductPrice = products[key].price;
        let tempProductTotalPrice = tempProductPrice * numOptionalInclusionsNoHost[key];
        optionalInclusionsPrice += tempProductTotalPrice;
      }
    }

    return packagePrice + cakePrice + optionalInclusionsPrice;
  }



  // ===============================================================================================
  // Save the form's current state
  _save(_name, _sCurrent, _sChanges, _calculatePrice = true) {
    let newState = {};

    // Calculate a new price if requested
    if (_calculatePrice) {
      _sChanges.app_totalPrice = this._recalculatePrice(_sCurrent, _sChanges);
    }

    // Get most up-to-date version of state, including any current changes
    for (let key in _sCurrent) {
      switch (key) {
        case "app_activeSlide":
        case "app_visitedSlides":
        case "cake_isByo":
        case "cake_numCakes":
        case "cake_numOptionalInclusionsNoHost":
        case "datetime_selDate":
        case "datetime_selTime":
        case "intro_counter":
        case "intro_starList":
        case "location_query":
        case "location_selLocation":
        case "package_numAdults":
        case "package_numChilds":
        case "summary_firstName":
        case "summary_lastName":
        case "summary_email":
        case "summary_phone":
        case "summary_reqs":
        case "summary_tAndC":
        case "summary_privacy":
        case "eventType":
        // case "package_isPremium":


          if      (_sChanges.hasOwnProperty(key)) { newState[key] = _sChanges[key]; }
          else if (_sCurrent.hasOwnProperty(key)) { newState[key] = _sCurrent[key]; }

          // Convert datetimes
          if (key === "datetime_selDate" && newState[key]) {
            if (Moment.isMoment(newState[key])) {
              // newState[key] = (newState[key]).toISOString();
              newState[key] = (newState[key]).format("YYYY-MM-DD");
            }
          }

          // Convert timeslot
          // Convert timeslot
          else if (key === "datetime_selTime" && newState[key]) {
            newState[key] = newState[key].time;
          }

          // Convert location
          else if (key === "location_selLocation" && newState[key]) {
            newState[key] = newState[key].id;
          }

          break;

        default:
          // No default action

      }
    }



    // Save the state!!
    // console.log(`NEW STATE -- ${_name}:\n `, newState);
    if (!this.editMode) {
      window.sessionStorage[this.bookmark] = JSON.stringify(newState);
    }

    return _sChanges;
  }



  // ===============================================================================================
  // Load the form's current state
  _load(_sCurrent, _sChanges) {
    let newState = {};



    // If we got an editState, we need to restore it!
    if (_sChanges["_editResponse"]) {
      this.editMode = true;

      let _es = _sChanges["_editResponse"];
      // console.log("EDIT STATE:\n ", _es);
      let foundErrors = false;

      // Copy info from changes (except the editState)
      for (let key in _sChanges) {
        if (_sChanges.hasOwnProperty(key) &&
            key !== "_editResponse" &&
            key !== "_loginResponse") {
          newState[key] = _sChanges[key];
        }
      }

      // console.log("NEW STATE:\n ", newState);



      // ----------------------------------------
      // Import IntroSection state
      newState["intro_counter"]  = 0;
      newState["intro_starList"] = [];

      if ( !_es.hasOwnProperty("kids_detail") ) {
        foundErrors = true;
        // console.log("EDIT STATE:\n IntroSection import failed (missing)");
      }
      else {
        let _kidsDetails = JSON.parse(_es["kids_detail"]);
        if (_kidsDetails && _kidsDetails.kids && _kidsDetails.kids.length) {
          let _k = _kidsDetails.kids;
          for (let i = 0; i < _k.length; i++) {
            newState["intro_starList"].push({
              id:   _k[i].id,
              name: _k[i].name,
              age:  _k[i].age,
            });
            newState["intro_counter"] = Math.max(newState["intro_counter"], _k[i].id);
          }
        }
      }

      if ( newState["intro_starList"].length < 1 ) {
        foundErrors = true;
        // console.log("EDIT STATE:\n IntroSection import failed", "\n_es['kids_detail']:", _es["kids_detail"]);
      }
      // ----------------------------------------



      // ----------------------------------------
      // Import PackageSection state
      if ( !_es.hasOwnProperty("kids_in_party") ||
           !_es.hasOwnProperty("adults_in_party") ) {
        foundErrors = true;
        // console.log("EDIT STATE:\n PackageSection import failed (missing)", _es["kids_in_party"], _es["adults_in_party"], _es["premium_party_package"]);
      }
      else {
        newState["package_numChilds"] =  _es["kids_in_party"];
        newState["package_numAdults"] =  _es["adults_in_party"];
        // newState["package_isPremium"] = (_es["premium_party_package"] === 1) ? true : false;
      }
      // ----------------------------------------



      // ----------------------------------------
      // Import LocationSection state
      newState["location_query"]       = "";
      newState["location_selLocation"] = null;

      if ( !_es.hasOwnProperty("restaurants_id") ) {
        foundErrors = true;
        // console.log("EDIT STATE:\n LocationSection import failed (missing)");
      }
      else {
        let rId = parseInt(_es["restaurants_id"], 10);

        if (typeof rId === "number" && !isNaN(rId) && newState["app_cache_locations"]) {
          let locs = newState["app_cache_locations"];

          for (let i = 0; i < locs.length; i++) {
            if (locs[i].id === rId) {
              newState["location_selLocation"] = locs[i];
              newState["location_query"] = locs[i].name.toLowerCase();
              break;
            }
          }
        }
      }

      if ( !newState["location_selLocation"] ) {
        foundErrors = true;
        // console.log("EDIT STATE:\n LocationSection import failed", "\n_es['restaurants_id']:", _es["restaurants_id"]);
      }
      // ----------------------------------------



      // ----------------------------------------
      // Import DatetimeSection state
      newState["datetime_selDate"] = null;
      newState["datetime_selTime"] = null;

      if ( !_es.hasOwnProperty("party_date") ||
           !_es.hasOwnProperty("party_duration") ) {
        foundErrors = true;
        // console.log("EDIT STATE:\n DatetimeSection import failed (missing something)", _es["party_date"], _es["party_duration"]);
      }
      else {
        if (_es["party_date"].match(/^\d{4}-\d{2}-\d{2}$/)) {
          // let newDate = Moment(newState[key]);
          let parts = (_es["party_date"]).split("-");
          let newDate = Moment()
            .year(  parseInt(parts[0], 10)     )
            .month( parseInt(parts[1], 10) - 1 )
            .date(  parseInt(parts[2], 10)     );
          if (Moment().isValid(newDate)) {
            newState["datetime_selDate"] = newDate;
          }
        }
        newState["datetime_selTime"] = { time: _es["party_duration"] };
      }

      if ( !newState["datetime_selDate"] || !newState["datetime_selTime"] ) {
        foundErrors = true;
        // console.log("EDIT STATE:\n DatetimeSection import failed", "\n_es['party_date']:",     _es["party_date"], "\n_es['party_duration']:", _es["party_duration"]);
      }
      // ----------------------------------------



      // ----------------------------------------
      // Import CakeSection state
      newState["cake_numCakes"] = 0;
      newState["cake_isByo"]    = false;
      newState["cake_numOptionalInclusionsNoHost"] = 0;
      if ( !_es.hasOwnProperty("cake") ) {
        foundErrors = true;
        // console.log("EDIT STATE:\n CakeSection import failed (missing)");
      }
      else {
        let cakes = parseInt(_es["cake"], 10);

        if (typeof cakes === "number" && !isNaN(cakes)) {
          newState["cake_numCakes"] = Math.max(cakes, 1);
          newState["cake_isByo"]    = (cakes < 1) ? true : false;
        }
      }

      if ( newState["cake_numCakes"] === 0 && newState["cake_isByo"] === false ) {
        foundErrors = true;
        // console.log("EDIT STATE:\n CakeSection import failed", "\n_es['cake']:", _es["cake"]);
      }
      // ----------------------------------------



      // ----------------------------------------
      // Import SummarySection state
      newState["summary_firstName"] = null;
      newState["summary_lastName"] = null;
      newState["summary_email"] = null;
      newState["summary_phone"] = null;
      newState["summary_reqs"]  = null;
      newState["summary_tAndC"]  = null;
      newState["summary_privacy"]  = null;

      if (!_es.hasOwnProperty("special_requirements") || !_sChanges["_loginResponse"] ) {
        foundErrors = true
        // console.log("EDIT STATE:\n SummarySection import failed (missing something)", _es["special_requirements"], _sChanges["_loginResponse"])
      } else {
        if (_sChanges["_loginResponse"].hasOwnProperty("mobile_phone")) {
          newState["summary_phone"] = _sChanges["_loginResponse"].mobile_phone;
        }
        newState["summary_reqs"] = _es["special_requirements"];
        if (newState["summary_reqs"] === null) {
          newState["summary_reqs"] = "";
        }
      }

      if (!newState["summary_firstName"] && !newState["summary_lastName"] && !newState["summary_email"] && !newState["summary_phone"] && (!newState["summary_reqs"] && newState["summary_reqs"] !== "") ) {
        foundErrors = true
        // console.log(
        //   "EDIT STATE:\n SummarySection import failed",
        //   "\n_es['special_requirements']:", _es["special_requirements"],
        //   "\n_sChanges['_loginResponse']:", _sChanges["_loginResponse"],
        //   "\nnewState['summary_firstName']:", newState["summary_firstName"],
        //   "\nnewState['summary_lastName']:", newState["summary_lastName"],
        //   "\nnewState['summary_email']:", newState["summary_email"],
        //   "\nnewState['summary_phone']:", newState["summary_phone"],
        //   "\nnewState['summary_reqs']:", newState["summary_reqs"]
        // );
      }
      // ----------------------------------------
      // foundErrors = true;  // Force error
      if (foundErrors) { return null; }
    }

    // Otherwise, we need to load our saved state
    else {
      // Try to get the old state from session, if it exists
      let oldState = window.sessionStorage[this.bookmark];
      oldState = (oldState) ? JSON.parse(oldState) : null;

      // console.log("OLD STATE:\n ", oldState);

      // Verify this is actually a saved state
      if (oldState && oldState.hasOwnProperty("app_activeSlide")) {

        // Get most up-to-date version of state (old state > changed state > current state)
        for (let key in _sCurrent) {
          if      ( oldState.hasOwnProperty(key)) { newState[key] =  oldState[key]; }
          else if (_sChanges.hasOwnProperty(key)) { newState[key] = _sChanges[key]; }
          else if (_sCurrent.hasOwnProperty(key)) { newState[key] = _sCurrent[key]; }

          // Convert datetimes
          if (key === "datetime_selDate" && newState[key] &&
             (newState[key]).match(/^\d{4}-\d{2}-\d{2}$/)) {
            // let newDate = Moment(newState[key]);
            let parts = (newState[key]).split("-");
            let newDate = Moment()
              .year(  parseInt(parts[0], 10)     )
              .month( parseInt(parts[1], 10) - 1 )
              .date(  parseInt(parts[2], 10)     );
            if (Moment().isValid(newDate)) {
              newState[key] = newDate;
            }
          }

          // Convert timeslot
          else if (key === "datetime_selTime" && newState[key]) {
            newState[key] = { time: newState[key] };
          }

          // Convert location
          else if (key === "location_selLocation" && newState[key]) {
            let locs = _sChanges["app_cache_locations"];
            for (let i = 0; i < locs.length; i++) {
              if (locs[i].id === newState[key]) {
                newState[key] = locs[i];
                break;
              }
            }
            if (typeof newState[key] === "number") {
              newState[key] = null;
            }
          }
        }
      }



      // If we aren't loading the saved state,
      else {

        // Get most up-to-date version of state (changed state > current state)
        for (let key in _sCurrent) {
          if      (_sChanges.hasOwnProperty(key)) { newState[key] = _sChanges[key]; }
          else if (_sCurrent.hasOwnProperty(key)) { newState[key] = _sCurrent[key]; }
        }
      }
    }



    // console.log("CHANGED STATE:", _sChanges);
    // console.log("NEW STATE:", newState);

    // Calculate a base price
    newState.app_totalPrice = this._recalculatePrice(newState, {});

    // console.log("FINAL STATE:", newState);

    return newState;
  }



  // ===============================================================================================
  // Chooses how to handle a specific state change
  handleEvent(_state, _name, _event) {
    if (typeof _name !== "string") {
      // console.log(`EVENT:\n handleAppEvent() -> invalid event name!`, _name, _event);
      return;
    }

    // console.log(`EVENT:\n handleAppEvent(${_name})`, _event);



    // Handle specific events
    switch(_name) {

      // -------------------------------------------------------------------------------------------
      //   APP events
      // -------------------------------------------------------------------------------------------

      // APP: Prices changed (via API)
      case this.events.APP_LOADED: {
        return this._load(_state, _event);
      }

      // APP: Prices changed (via API)
      case this.events.APP_SLIDE_CHANGED: {
        let visitedSlides = _state.app_visitedSlides;

        if (!_state.app_visitedSlides.length) { visitedSlides = []; }
        if (visitedSlides.indexOf(_event) === -1) {
          visitedSlides.push(_event);
        }

        return this._save(_name, _state, {
          app_visitedSlides: visitedSlides,
          app_activeSlide:   _event,
          app_activeSlideId:   _state.items[_event].id,
        });
      }

      // APP: Prices changed (via API)
      case this.events.APP_PRICE_CHANGED: {
        return this._save(_name, _state, {}, true);
      }

      // APP: Wipe all data (when submitting)
      case this.events.APP_WIPE_DATA: {
        // console.log(this.events.APP_WIPE_DATA);
        window.sessionStorage.removeItem(this.bookmark);
        return null;
      }



      // EVENTTYPE: Modify event type
      case this.events.EVENTTYPE_MOD_TYPE: {
        return this._save(_name, _state, {
          eventType: _event,
        }, true);
      }


      // -------------------------------------------------------------------------------------------
      //  INTRO events
      // -------------------------------------------------------------------------------------------

      // INTRO: Add child
      case this.events.INTRO_ADD_CHILD: {
        let newList  = _state.intro_starList.slice();
        let newIndex = _state.intro_counter + 1;

        newList.push({
          id:   newIndex,
          name: _event.name,
          age:  _event.age,
        });

        return this._save(_name, _state, {
          intro_counter:     newIndex,
          intro_starList:    newList,
          // package_numChilds: _state.package_numChilds + 1,
          datetime_selTime:  null,
        }, true);
      }



      // INTRO: Modify child
      case this.events.INTRO_MOD_CHILD: {
        let newList = _state.intro_starList.slice();

        for (let i = 0; i < newList.length; i++) {
          if (newList[i].id === _event.id) {
            newList[i].name = _event.name;
            newList[i].age  = _event.age;
          }
        }

        return this._save(_name, _state, {
          intro_starList: newList,
        }, true);
      }



      // INTRO: Remove child
      case this.events.INTRO_REM_CHILD: {
        let starList = _state.intro_starList;
        let index = null;

        for (let i = 0; i < starList.length; i++) {
          if (starList[i].id === _event.id) {
            index = i; break;
          }
        }

        if (index !== null) {
          starList.splice(index, 1);
          return this._save(_name, _state, {
            intro_starList:    starList,
            // package_numChilds: _state.package_numChilds - 1,
          datetime_selTime:    null,
          }, true);
        }

        return null;
      }



      // -------------------------------------------------------------------------------------------
      //  PACKAGE events
      // -------------------------------------------------------------------------------------------

      // PACKAGE: Modify amount of children
      case this.events.PACKAGE_MOD_CHILD: {
        return this._save(_name, _state, {
          package_numChilds: _event,
          datetime_selTime:  null,
        }, true);
      }



      // PACKAGE: Modify amount of adults
      case this.events.PACKAGE_MOD_ADULT: {
        return this._save(_name, _state, {
          package_numAdults: _event,
          datetime_selTime:  null,
        });
      }



      // PACKAGE: Toggle premium package
      // case this.events.PACKAGE_MOD_PREMIUM: {
      //   return this._save(_name, _state, {
      //     package_isPremium: _event,
      //   }, true);
      // }



      // -------------------------------------------------------------------------------------------
      //   CAKE events
      // -------------------------------------------------------------------------------------------

      // CAKE: Modify amount of cakes
      case this.events.CAKE_MOD_CAKE: {
        return this._save(_name, _state, {
          cake_numCakes: _event,
        }, true);
      }



      // CAKE: Toggle BYO cake package
      case this.events.CAKE_MOD_BYO: {
        return this._save(_name, _state, {
          cake_isByo: _event,
        }, true);
      }



            // CAKE: Modify amount of cakes
      case this.events.CAKE_MOD_OPTIONAL_INCLUSIONS_NO_HOST: {
        return this._save(_name, _state, {
          cake_numOptionalInclusionsNoHost: {
            ..._state.cake_numOptionalInclusionsNoHost,
            [_event.product_name]: _event.amount
          },
        }, true);
      }

      // -------------------------------------------------------------------------------------------
      //   LOCATION events
      // -------------------------------------------------------------------------------------------

      // LOCATION: Modify the location search query
      case this.events.LOCATION_MOD_QUERY: {
        return this._save(_name, _state, {
          location_query: _event,
        });
      }

      // LOCATION: Modify the selected location
      case this.events.LOCATION_MOD_DEST: {
        return this._save(_name, _state, {
          location_selLocation: _event,
          datetime_selTime:     null,
        });
      }



      // -------------------------------------------------------------------------------------------
      //   DATETIME events
      // -------------------------------------------------------------------------------------------

      // DATETIME: Modify the selected date
      case this.events.DATETIME_MOD_DATE: {
        return this._save(_name, _state, {
          datetime_selDate: _event,
          datetime_selTime: null,
        });
      }



      // DATETIME: Modify the selected time
      case this.events.DATETIME_MOD_TIME: {
        return this._save(_name, _state, {
          datetime_selTime: _event,
        });
      }



      // -------------------------------------------------------------------------------------------
      //   SUMMARY events
      // -------------------------------------------------------------------------------------------

      // SUMMARY: Modify first name
      case this.events.SUMMARY_MOD_FIRST_NAME: {
        return this._save(_name, _state, {
          summary_firstName: _event,
        });
      }

      // SUMMARY: Modify last name
      case this.events.SUMMARY_MOD_LAST_NAME: {
        return this._save(_name, _state, {
          summary_lastName: _event,
        });
      }

      // SUMMARY: Modify email
      case this.events.SUMMARY_MOD_EMAIL: {
        return this._save(_name, _state, {
          summary_email: _event,
        });
      }

      // SUMMARY: Modify phone number
      case this.events.SUMMARY_MOD_PHONE: {
        return this._save(_name, _state, {
          summary_phone: _event,
        });
      }

      // SUMMARY: Modify special requirements
      case this.events.SUMMARY_MOD_REQS: {
        return this._save(_name, _state, {
          summary_reqs: _event,
        });
      }

      // SUMMARY: Toggle Terms and Conditions
      case this.events.SUMMARY_TERMS_AND_COND: {
        return this._save(_name, _state, {
          summary_tAndC: _event,
        }, true);
      }

      // SUMMARY: Toggle Privacy collection statement
      case this.events.SUMMARY_PRIVACY_COLLECTION: {
        return this._save(_name, _state, {
          summary_privacy: _event,
        }, true);
      }

      // -------------------------------------------------------------------------------------------
      // DEFAULT: Print out an error
      default: {
        console.log(`EVENT:\n handleAppEvent(${_name}) -> unknown event name!`);
      }
    }



    return null;
  }

}



export default new Events();
